import { Table } from 'components/generic';
import { getColor } from 'utils';
import styled from 'styled-components';

export const MemberContainer = styled(Table)`
    border: 0.0625rem solid #ccc;
    border-radius: 0.25rem;
    border-color: ${props => getColor(props, 'mediumGrey')};
`;